import SocialFeed, { SocialFeedTemplate } from '@esign/social-feed';
import Swiper from 'swiper';
import clamp from '../layout/clamp';

export default () => {
  const socialFeedContainer = document.querySelector('.js-social-feed');

  // social media
  const pictureSources = (srcsets) => {
    let picture = '';

    Object.entries(srcsets).forEach(([, value]) => {
      picture = `${picture}<source media="${value.mediaQuery}" srcset="${value.url}" type="image/${value.extension}">`;
    });

    return picture;
  };

  if (socialFeedContainer) {
    // Get the type from the data attribute
    const type = socialFeedContainer.getAttribute('data-feed-type');
    if (type === 'fullscreen' || type === 'regular') {
      new SocialFeed({
        gridClass: `grid ${
          type === 'fullscreen' ? 'grid--gutter-0' : 'grid--social-regular'
        } social-grid`,
        itemClass: 'grid__item one-half medium--one-quarter social-grid__item',
        template: new SocialFeedTemplate({
          itemTemplate: (item) =>
            `<div class="grid__item one-half medium--one-quarter social-grid__item">
            <a href="${item.url}" target="_blank" class="social-grid__item link" rel="nofollow">
              <div class="social-grid__item-content">
                <p>${item.body}</p>
              </div>
              <div class="visual">
                ${
                  (item.media_type === 'image' || item.media_type === 'CAROUSEL_ALBUM') &&
                  item.photo &&
                  item.srcsets.length
                    ? `<picture>
                        ${pictureSources(item.srcsets)}
                        <img loading="lazy" src="${item.photo}" alt=""/>
                      </picture>`
                    : ''
                }
                ${
                  (item.media_type === 'image' || item.media_type === 'CAROUSEL_ALBUM') &&
                  item.photo &&
                  !item.srcsets.length
                    ? `<img loading="lazy" src="${item.photo}" alt="" />`
                    : ''
                }
                ${
                  item.media_type === 'video' && item.photo
                    ? `<video autoplay playsinline muted loop>
                        <source src="${item.photo}" type="video/mp4">
                      </video>`
                    : ''
                }
              </div>
              <svg class="icon icon-instagram">
                <use xlink:href="#icon-instagram"></use>
              </svg>
            </a>
          </div>`,
        }),
        onReady: () => {
          clamp(socialFeedContainer, '.social-grid__item-content p', 10);
        },
      });
    } else {
      new SocialFeed({
        template: new SocialFeedTemplate({
          containerTemplate: (items) =>
            `<div class="slider slider--arrows js-socials-slider">
                <div class="swiper-wrapper">
                ${items}
                </div>
                <!-- Add Arrows -->
                <div class="arrow-group" data-aos="fade-up" data-aos-delay="50">
                  <div class="swiper-prev js-slider--prev">
                    <svg class="icon icon-arrow-down">
                      <use xlink:href="#icon-arrow-down"/>
                    </svg>
                  </div>

                  <div class="swiper-next js-slider--next">
                    <svg class="icon icon-arrow-down">
                      <use xlink:href="#icon-arrow-down"/>
                    </svg>
                  </div>
                </div>
            </div>`,
          itemTemplate: (item) =>
            `<div class="swiper-slide">
              <a href="${item.url}" target="_blank" class="social-grid__item link" rel="nofollow">
                <div class="social-grid__item-content">
                  <p>${item.body}</p>
                </div>
                <div class="visual">
                  ${
                    (item.media_type === 'image' || item.media_type === 'CAROUSEL_ALBUM') &&
                    item.photo &&
                    item.srcsets.length
                      ? `<picture>
                          ${pictureSources(item.srcsets)}
                          <img loading="lazy" src="${item.photo}" alt=""/>
                        </picture>`
                      : ''
                  }
                  ${
                    (item.media_type === 'image' || item.media_type === 'CAROUSEL_ALBUM') &&
                    item.photo &&
                    !item.srcsets.length
                      ? `<img loading="lazy" src="${item.photo}" alt="" />`
                      : ''
                  }
                  ${
                    item.media_type === 'video' && item.photo
                      ? `<video autoplay playsinline muted loop>
                          <source src="${item.photo}" type="video/mp4">
                        </video>`
                      : ''
                  }
                </div>
                <svg class="icon icon-instagram">
                  <use xlink:href="#icon-instagram"></use>
                </svg>
              </a>
            </div>`,
        }),
        onReady: () => {
          clamp(socialFeedContainer, '.social-grid__item-content p', 10);

          new Swiper('.js-socials-slider', {
            direction: 'horizontal',
            loop: true,
            spaceBetween: 0,
            slidesPerView: 2,
            preloadImages: true,
            updateOnImagesReady: true,
            watchSlidesVisibility: true,
            effect: 'fade',
            a11y: true,
            navigation: {
              nextEl: '.js-slider--next',
              prevEl: '.js-slider--prev',
            },
            breakpoints: {
              1200: {
                slidesPerView: 4,
                spaceBetween: 0,
              },
            },
          });
        },
      });
    }
  }
};
